import React, { useState } from 'react'
import { layerManage } from '@/utils/layer'
import { Modal } from '@/components/dialog/modal'
import { Row } from '@/components/layout/layout'
import { useRequest } from 'ahooks'
import Input from '@/components/input/input'
import $msg from '@/utils/message'
import { $post } from '@/api'

interface StaffRemakDialogProps {
    nickname: string
    realname: string
    staffId: number
    refresh: () => void
}

const StaffRemakDialog: React.FC<StaffRemakDialogProps> = props => {
    const [remark, setRemark] = useState<string>('')

    const refuseReq = useRequest(
        () =>
            $post({
                url: '/staff/staffapplicationrefuse',
                params: {
                    refuse_reason: remark,
                    staff_application_record_id: props.staffId,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                layerManage.pop()
                $msg('success', '操作成功')
                props.refresh()
            },
            onError: e => $msg('error', e.message),
        },
    )

    return (
        <Modal
            isShow
            type="danger"
            title="拒绝理由"
            onClose={() => layerManage.pop()}
            onCancel={() => layerManage.pop()}
            onConfirm={() => {
                if (refuseReq.loading) return
                refuseReq.run()
            }}
        >
            <div>
                <Row data-align-items-center data-font-size-20 data-font-weight-600 data-color-000>
                    确认拒绝{' '}
                    <div data-color-danger data-margin-h-6>
                        {props.nickname}（{props.realname}）
                    </div>{' '}
                    的员工申请吗？
                </Row>
                <Input
                    styles={{ height: '40px', margin: '10px 0' }}
                    value={remark}
                    error
                    maxLength={50}
                    onChange={e => setRemark(e.target.value)}
                    inputsuffix={() => (
                        <div data-width-40 data-text-align-right data-color-999>
                            {remark.length}/50
                        </div>
                    )}
                ></Input>
            </div>
        </Modal>
    )
}

export default StaffRemakDialog
